import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class CustomerUserList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      merchants: [],
      users: [],
      selectedUser: "",
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const storedMerchantId = sessionStorage.getItem("merchantId");
    const { selectedMerchant: stateMerchant } = this.props.location.state || {};
    const selectedMerchant = stateMerchant || storedMerchantId;
    const canWrite = this.hasPermission([Scopes.CUSTOMERS_USERS_WRITE])
    this.setState({canWrite})
    if (selectedMerchant) {
        
      // If merchantId is stored, use it directly
      this.setState({ selectedMerchant }, this.callPage);
    } else {
      // If no merchantId in storage, fetch list of merchants to display in dropdown
      this.fetchMerchants();
    }
  }

  // Fetches the list of merchants when merchantId is not in sessionStorage
  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.callPage();
      }
    }
  };
  async callPage() {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;

    const pathname = `customers/${selectedMerchant}/users`;
    const response = await this.engine.getItem(pathname);
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          user: `${item.user.firstName ?? ""} ${item.user.lastName ?? ""}`.trim(),
          phone: item.user.phoneNumber ?? "",
          email: item.user.email ?? "",
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }
    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  async handleDelete(valueId) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedMerchant } = this.state;
      const result = await this.engine.deleteItem(
        `customers/${selectedMerchant}/users`,
        valueId
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleEdit(index, dataId) {
    const data = this.state.dataSource[index].data;
    const { selectedMerchant } = this.state;

    this.props.history.push({
      pathname: `/admin/customer_user/${selectedMerchant}/edit/${dataId}`,
      state: { selectedMerchant },
      data,
    });
  }
  handleManage(index, dataId) {
    const data = this.state.dataSource[index].data;
    const { selectedCustomer } = this.state;

    this.props.history.push({
      pathname: `/admin/customer_vehicles/${dataId}`,
      state: { selectedCustomer, data },
    });
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          {
            key: "vehicles",
            icon: "fa fa-car",
            label: "Manage Vehicle",
            onClick: () => this.handleManage(index, item.id),
          },
          deleteAction(() => this.handleDelete(item.id)),
        ]}
      />
    );
  }

  // Updates selected merchant and fetches data
  handleMerchantSelect = (event) => {
    const selectedMerchant = event.value;
    this.setState({ selectedMerchant }, () => {
      this.props.history.push(`/admin/customer_user/${selectedMerchant}/users`);
      this.callPage();
    });
  };

  handleAdd() {
    const { selectedMerchant } = this.state;

    if (!selectedMerchant) {
      alert(strings.select + " " + strings.merchant);
      return;
    }

    this.props.history.push({
      pathname: `/admin/customer_user/${selectedMerchant}/add`,
      state: { selectedMerchant },
    });
  }

  async handleSync() {
    this.setState({ isLoading: true });
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;

    const pathname = `customers/${selectedMerchant}/users/sync`;

    try {
      const response = await this.engine.getItem(pathname);
      if (response && response.status === 200) this.callPage();
    } catch (error) {
      alert("Something went Wrong: ", error.message);
    }
    this.setState({ isLoading: false });
  }

  render() {
    const { 
      merchants,
      selectedMerchant, 
      dataSource, 
      isLoading,
      canWrite} = this.state;

    let columns = [
      { Header: strings.username, accessor: "user" },
      { Header: strings.phone, accessor: "phone" },
      { Header: strings.email, accessor: "email" },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite && (
                    <Button
                      color="primary"
                      className="pull-right"
                      onClick={() => this.handleAdd()}
                    >
                      {strings.add}
                    </Button>
                  )}
                  {canWrite && (
                    <Button
                      className="hover-button pull-left"
                      onClick={() => this.handleSync()}
                    >
                      {strings.sync}
                    </Button>
                  )}
                  {!sessionStorage.getItem("merchantId") &&
                    merchants.length !== 1 && (
                      <SelectRow
                        label={strings.merchant}
                        name="selectedMerchant"
                        defaultValue={selectedMerchant}
                        data={merchants}
                        changeInput={this.handleMerchantSelect}
                        placeholder={strings.select}
                      />
                    )}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(CustomerUserList);
